import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-tratamiento-datos',
  templateUrl: './tratamiento-datos.component.html',
  styleUrls: ['./tratamiento-datos.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TratamientosDatosComponent implements OnInit {
 // condicionesChecked = false;
  constructor(public dialogRef: MatDialogRef<TratamientosDatosComponent>,
  	@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  submit() {
   this.dialogRef.close();
  }

  check(){
   // this.condicionesChecked = !this.condicionesChecked
  }

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/login/components/condiciones/tratamiento-datos.component.ts